import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { CleverTapConstents } from 'src/app/services/constants';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-courses',
  templateUrl: './courses.component.html',
  styleUrls: ['./courses.component.scss']
})
export class CoursesComponent implements OnInit {

  courses: any = []

  searchTerm: string = '';

  index: any;

  instituteName: string = ''

  totalPages: number = 0;

  currentPage = 0;

  currentInstituteCourses:any;

  private searchTerms = new Subject<string>();



  constructor(public util: UtilService) { }

  ngOnInit(): void {

    this.courses = this.util.getCache('currentInstituteCourses')?.content || JSON.parse(localStorage.getItem('currentInstituteCourses') || '{}')?.content ;
    this.instituteName = this.util.getCache('currentInstitute')?.name || JSON.parse(localStorage.getItem('currentInstitute') || '{}')?.name;
    this.totalPages = Math.ceil((this.util.getCache("currentInstituteCourses")?.totalElements || JSON.parse(localStorage.getItem('currentInstituteCourses') || '{}')?.totalElements) / (this.util.getCache("currentInstituteCourses")?.pageSize || JSON.parse(localStorage.getItem('currentInstituteCourses') || '{}')?.pageSize) );
    this.searchCourses();
//     if(sessionStorage.getItem('route')=='courses'){s
//       const course: any = JSON.parse(localStorage.getItem('product') || '{}')
//       // this.util.loadProduct(JSON.parse(localStorage.getItem('product') || '{}'),JSON.parse(localStorage.getItem('cat') || '{}'),'','');
//       this.util.openCourses(JSON.parse(course));
// // this.util.route('course')
//     }
  }



  back() {
    sessionStorage.removeItem('course');
    localStorage.removeItem('currentInstituteCourses');
    if( localStorage.getItem('cat' ) && localStorage.getItem('lat')){
      this.util.route('institutes');
    }
    else  this.util.route('home');

  }

  onInputChange() {
    this.searchTerms.next(this.searchTerm);
    this.currentPage = 0;
  }


  getDuration(terms: any[]) {
    let highestDurationTerm = null;
    if (terms && terms.length > 0) {
      highestDurationTerm = terms.reduce((prev, current) => {
        const prevDuration = parseInt(prev.termDurationInMonths, 10);
        const currentDuration = parseInt(current.termDurationInMonths, 10);
        return prevDuration > currentDuration ? prev : current;
      });
    }
    return highestDurationTerm;
  }



  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.getCourses();
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.getCourses();
    }
  }

  getCourses() {
    this.util.handleRequests('get', this.util.getUrl('courses_courses', [this.searchTerm, this.util.getCache('currentInstitute')?.id ||  JSON.parse(localStorage.getItem('currentInstitute') || '{}')?.id, this.currentPage, 6])).then(res => {
      this.courses = res.content;
      this.totalPages = Math.ceil(res.totalElements / res.pageSize);
    });
  }

  searchCourses() {
    this.searchTerms
      .pipe(
        debounceTime(800),
        distinctUntilChanged(),
        switchMap(searchTerm => this.util.handleRequests('get', this.util.getUrl('courses_courses', [searchTerm, this.util.getCache('currentInstitute')?.id || JSON.parse(localStorage.getItem('currentInstitute') || '{}')?.id , 0, 6]))))
      .subscribe(res => {
        this.courses = res.content;
        this.totalPages = Math.ceil(res.totalElements / res.pageSize)
      });
  }

  selectCourse(course: any) {
    this.util.setCache('currentInstituteCourses',course.course_name)
    const institute = this.util.getCache('currentInstitute') || JSON.parse(localStorage.getItem('currentInstitute') || '{}');
    const product = this.util.getCache('product') || JSON.parse(localStorage.getItem('product') || '{}');

    this.util.handleRequests('post', this.util.getUrl('loan_create'), {
      product: product?.id,
      productCategory: institute.categoryId,
      fromQR: false,
    }).then((loan: any) => {
      this.util.handleRequests('put', this.util.getUrl('institute_select', [loan.content.loanId]), {
        centerId: institute.id,
        courseId: course.course_id,

      }).then((res: any) => {
        this.util.getLoandetails().then(() => {
         this.util.clearInstitudeData();
          this.util.route('loanDetails');
        });
      })
      this.util.cleverTapEventCall(CleverTapConstents.select_course,
      //   {
      //   'coachingName':"" || 'NA',
      //   'courseName':"" || 'NA',
      //   'totalFees':"" || 'NA',
      //   'tenure':"" || 'NA',
      //   'loanId': "",
      //   'productCode': ''
      // }
      );
    });

  }

}
